<template>
  <div class="note-category-overview" v-bind:class="{loaded}">
    <div v-if="!loaded">
      <Skeleton class="skeleton"
                v-bind:loading="true"
                style="width: 200px;height: 20px;display: inline-block;margin: 13px 16px;"></Skeleton>
      <div style="height: 0px; display: block; border-top: solid 1px #d9d9d9;"></div>
      <Skeleton class="skeleton"
                v-bind:loading="true"
                style="width: 200px;height: 20px;display: inline-block;margin: 13px 16px"></Skeleton>
      <div style="height: 0px; display: block; border-top: solid 1px #d9d9d9;"></div>
      <Skeleton class="skeleton"
                v-bind:loading="true"
                style="width: 200px;height: 20px;display: inline-block;margin: 13px 16px"></Skeleton>
      <div style="height: 0px; display: block; border-top: solid 1px #d9d9d9;"></div>
      <Skeleton class="skeleton"
                v-bind:loading="true"
                style="width: 200px;height: 20px;display: inline-block;margin: 13px 16px"></Skeleton>
      <div style="height: 0px; display: block; border-top: solid 1px #d9d9d9;"></div>
      <Skeleton class="skeleton"
                v-bind:loading="true"
                style="width: 200px;height: 20px;display: inline-block;margin: 13px 16px"></Skeleton>
      <div style="height: 0px; display: block; border-top: solid 1px #d9d9d9;"></div>
      <Skeleton class="skeleton"
                v-bind:loading="true"
                style="width: 200px;height: 20px;display: inline-block;margin: 13px 16px"></Skeleton>
    </div>

    <lazy-component v-on:intersected="onInit" v-bind:is-intersected="forceIntersect">
      <a-collapse v-bind:active-key="activeNoteCollapsePanels" v-on:change="handleCollapse">
        <a-collapse-panel v-for="category in categories"
                          v-bind:key="category.name"
                          v-bind:header="category.name"
                          class="no-padding note-category" v-if="loaded">

          <template v-slot:extra>
            <a-badge
                v-if="getCategoryAttachableCount(category) > 0"
                v-bind:count="getCategoryAttachableCount(category)"
                v-bind:show-zero="true"
                v-bind:number-style="{ backgroundColor: 'red' }"
                v-bind:title="'Notities onder ' + category.name"/>
          </template>
          <PaginatedCategoryComponent
              v-bind:category-id="category.id"
              v-bind:customer-id="customerId"
          />
        </a-collapse-panel>
      </a-collapse>
    </lazy-component>
  </div>
</template>

<script>
import store from '~/store'
import noteModule from '~/modules/note/store'
import { mapActions, mapGetters } from 'vuex'
import PaginatedCategoryComponent from './PaginatedCategoryComponent'
import categoryApi from '~/api/category'
import { Skeleton } from 'vue-loading-skeleton'

export default {
  name: 'NoteCategoryOverviewComponent',
  components: {
    PaginatedCategoryComponent,
    Skeleton,
  },
  props: {
    customerId: {
      required: true,
      type: [String, Number]
    }
  },
  data () {
    return {
      categories: null,
      loaded: false
    }
  },
  created () {
    if (!store.hasModule('note')) {
      store.registerModule('note', noteModule)
    }

    this.initialiseStore()
  },
  computed: {
    ...mapGetters([
      'forceIntersect'
    ]),
    ...mapGetters('note', [
      'activeNoteCollapsePanels'
    ]),
  },
  methods: {
    ...mapActions('note', [
      'setActiveNoteCollapsePanels',
      'initialiseStore',
    ]),
    async onInit () {
      await categoryApi.getNoteCategories(this.customerId, ['attachable_count']).then((response) => {
        this.categories = response.data
      })

      this.loaded = true
    },
    handleCollapse (value) {
      this.setActiveNoteCollapsePanels(value)
    },
    getCategoryAttachableCount (category) {
      return category?.attachable_count?.data?.count || 0
    }
  }
}
</script>

<style scoped>

</style>